import { createMemoStyles } from '@wds/utils';
var useStyles = createMemoStyles(function (_ref) {
  var palette = _ref.palette,
    shadow = _ref.shadow;
  return {
    panel: {
      position: 'absolute',
      top: '100%',
      width: '516px',
      background: palette.background.light,
      boxShadow: shadow.space
    },
    leftBox: {
      maxWidth: '176px',
      whiteSpace: 'normal'
    },
    rightBox: {
      maxWidth: '300px',
      whiteSpace: 'normal',
      backgroundColor: palette.background.main
    },
    title: {
      borderBottom: "1px solid ".concat(palette.border.main)
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map